/* 3rd party libraries */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { GridModule } from '@progress/kendo-angular-grid';

/* our own custom components */
// import { SomeCustomComponent } from './some-custom/some-custom.component';



// All the “dumb” components and pipes should be implemented here. These components don’t import and inject services from core
// or other features in their constructors. They should receive all data though attributes in the template of the component using them.
// This all sums up to the fact that SharedModule doesn’t have any dependency to the rest of our application.
// It is also the perfect place to import and re-export Angular Material components.

@NgModule({
  declarations: [
    // SomeCustomComponent,
  ],
  imports: [
    /* angular stuff */
    CommonModule,
    FormsModule,
    /* 3rd party components */
    // GridModule
  ],
  exports: [
    /* angular stuff */
    CommonModule,
    FormsModule,
    // GridModule
    /* 3rd party components */
    // MdButtonModule,

    /* our own custom components */
    // SomeCustomComponent
  ]
})
export class SharedModule {
  static forRoot() {
    return {
      NgModule: SharedModule,
      providers: []
    };
  }
}
